<template>
    <div :class="containerCSSClass" :id="containerID"></div>
</template>

<script src='./applepay-place-order-button.js'></script>
